import { useContext } from "react";
import { langContext } from "../../api/Lang";

const el = {
    packagesHeading: (year: string) => `Προγράμματα σίτισης ${year}`,
    packageSub:
        "Για να εξασφαλίσετε ένα ισορροπημένο μεσημεριανό γεύμα για το παιδί σας, έχουμε επιμεληθεί ένα εβδομαδιαίο μενού που περιλαμβάνει όλες τις βασικές θρεπτικές ομάδες: όσπριο, κρέας, ψάρι ή θαλασσινό, λαδερό και κοτόπουλο.",
    packageSubStaff:
        "Για να εξασφαλίσεις ένα ισορροπημένο μεσημεριανό γεύμα καθημερινά, έχουμε επιμεληθεί ένα εβδομαδιαίο μενού που περιλαμβάνει όλες τις βασικές θρεπτικές ομάδες: όσπριο, κρέας, ψάρι ή θαλασσινό, λαδερό και κοτόπουλο.",
    packageChange:
        "Εάν για οποιοδήποτε λόγο κάποια μέρα το παιδί σας δεν επιθυμεί το γεύμα του πακέτου σίτισης, μπορεί να επιλέξει ανάμεσα σε επιλεγμένα γεύματα.",
    packageChangeStaff:
        "Εάν για οποιοδήποτε λόγο κάποια μέρα δεν επιθυμείς το γεύμα του πακέτου σίτισης, μπορείς να επιλέξεις ανάμεσα σε επιλεγμένα γεύματα.",
    specialOfferTitle: "Ειδική προσφορά για οικογένειες με 2 παιδιά και άνω",
    specialOfferPrefix:
        "Επίλεξε ένα από τα προγράμματα σίτισης για δύο παιδιά και κέρδισε επιπλέον έκπτωση",
    specialOfferSuffix: "για το δεύτερο παιδί",
    activeSubscriptions: "ΕΝΕΡΓΕΣ ΣΥΝΔΡΟΜΕΣ",
    availableToOrderInPrefix: "Διαθέσιμο για αγορά σε",
    availableToOrderInSuffix: "ημέρες",
    personnelPriceSuffix: "για το προσωπικό",
    mealIncludesHeading: "Κάθε γεύμα περιλαμβάνει:",
    mainCourse: "Κυρίως Πιάτο",
    saladAndBread: "Σαλάτα και ψωμί",
    fruit: "Φρούτο",
    moreInfoBuy: "Πληροφορίες & Αγορά",
    awaitingPaymentTitle: "Αναμονή πληρωμής παραγγελίας",
    awaitingPaymentSubtitle:
        "Η παραγγελία σου για το πακέτο σίτισης που έχεις επιλέξει δεν έχει ολοκληρωθεί, γιατί εκκρεμεί η πληρωμή.",
    cancelOrderSubtitle:
        "Είσαι σίγουρος ότι θέλεις να ακυρώσεις την παραγγελίας σου;",
    walletLabel: "Χρήση πορτοφολιού Lunchbox",
    infoAndTerms: "Πληροφορίες & όροι",
    selectPeople: "Επιλογή ατόμων",
    temporaryPaymentPause: "⚠️ Προσωρινή παύση πληρωμών",
    walletUpdateDelay: "⚠️ Καθυστέρηση ενημέρωσης υπολοίπου",
    acceptTermsPrefix: "Αποδέχομαι τους",
    termsAndConditions: "όρους",
    meal: "Γεύμα",
    salad: "Σαλάτα",
    dessert: "Επιδόρπιο",
    chooseRecipients: "Επίλεξε τα άτομα που θα λάβουν το πακέτο σίτισης",
    siblingDiscount: "Έκπτωση για αδέλφια",
    statusLabel: "Κατάσταση",
    purchaseDateLabel: "Ημερομηνία αγοράς:",
    packageValidityLabel: "Ισχύς πακέτου:",
    packagePriceLabel: "Τιμή πακέτου:",
    seeThePrefix: "Δες τους",
    termsLabel: "όρους",
    demoNoCreditCardTitle: "Αγορά credits",
    demoNoCreditCardMsg:
        "Δεν μπορείτε να προσθέσετε χρήματα με πιστωτική κάρτα στην έκδοση Demo.",
    availablePrefix: "Έχεις διαθέσιμα",
    willRemainPrefix: "Θα απομείνουν",
    totalLabel: "Σύνολο:",
    paymentPauseTitle: "⚠️ Προσωρινή παύση πληρωμών",
    walletDelayTitle: "⚠️ Καθυστέρηση ενημέρωσης υπολοίπου",
    needHelpPrefix: "Χρειάζεσαι βοήθεια; Επικοινώνησε μαζί μας στο",
    siblingDiscountVerifyFailedTitle: "Δεν επαληθεύτηκε η έκπτωση για αδέλφια",
    siblingDiscountVerifyFailedMsg:
        "Δεν ολοκληρώθηκε ο έλεγχος για έκπτωση αδελφών σε άλλο σχολείο του ομίλου. Το ποσό που εμφανίζεται μπορεί να είναι μεγαλύτερο από αυτό που δικαιούστε. Αν ισχύει, ανανεώστε τη σελίδα ή επικοινωνήστε μαζί μας πριν ολοκληρώσετε την πληρωμή.",
    stalePackageTempCleared:
        "Η εκκρεμής παραγγελία πακέτου έληξε και αφαιρέθηκε. Επίλεξε ξανά πακέτο από τη λίστα.",
    pendingPackageNotAvailable:
        "Αυτό το πακέτο δεν είναι πλέον διαθέσιμο για αγορά. Ακύρωσε την εκκρεμή παραγγελία και επίλεξε νέο πακέτο.",
    serverTimeNotReady: "Περιμένουμε συγχρονισμό ώρας. Δοκίμασε ξανά σε λίγο.",
    packageCopyFinishingByUs:
        "Το πακέτο σου καταχωρήθηκε, αλλά κάποια γεύματα δεν έχουν αντιγραφεί ακόμα. Θα τα ολοκληρώσουμε εμείς — δεν χρειάζεται να κάνεις κάτι.",
    packageRegisteredDlgTitle: "Πακέτο σίτισης",
};

const en: typeof el = {
    packagesHeading: (year: string) => `Meal packages ${year}`,
    packageSub:
        "To ensure your child receives a balanced lunch throughout the year, we have designed a menu that includes all the essential nutritional groups: legumes, meat, fish or seafood, vegetable-based dishes, and poultry.",
    packageSubStaff:
        "To ensure you will receive a balanced lunch throughout the year, we have designed a menu that includes all the essential nutritional groups: legumes, meat, fish or seafood, vegetable-based dishes, and poultry.",
    packageChange:
        "If, for any reason, some day your child doesn't wish to eat the dish of the meal package, you may choose from the selected dishes of the day",
    packageChangeStaff:
        "If, for any reason, some day you don't wish to eat the dish of the meal package, you may choose from the selected dishes of the day.",
    specialOfferTitle: "Special offer for families with 2 children or more",
    specialOfferPrefix:
        "Choose any of the meal packages for two children and receive an extra",
    specialOfferSuffix: "discount for your second child",
    activeSubscriptions: "ACTIVE SUBSCRIPTIONS",
    availableToOrderInPrefix: "Available to order in",
    availableToOrderInSuffix: "days",
    personnelPriceSuffix: "for personnel",
    mealIncludesHeading: "Every meal includes:",
    mainCourse: "Main Course",
    saladAndBread: "Salad and Bread",
    fruit: "Fruit",
    moreInfoBuy: "More info & Buy",
    awaitingPaymentTitle: "Waiting for order payment",
    awaitingPaymentSubtitle:
        "Your order for the meal package you have selected has not been completed, because payment is pending.",
    cancelOrderSubtitle: "Are you sure you want to cancel your order?",
    walletLabel: "Use Lunchbox wallet",
    infoAndTerms: "Info & terms",
    selectPeople: "Select people",
    temporaryPaymentPause: "⚠️ Temporary payment pause",
    walletUpdateDelay: "⚠️ Wallet update delay",
    acceptTermsPrefix: "I accept the",
    termsAndConditions: "terms & conditions",
    meal: "Meal",
    salad: "Salad",
    dessert: "Dessert",
    chooseRecipients: "Choose the persons that will receive the meal package",
    siblingDiscount: "Sibling discount",
    statusLabel: "Status",
    purchaseDateLabel: "Purchase date:",
    packageValidityLabel: "Package validity:",
    packagePriceLabel: "Package price:",
    seeThePrefix: "See the",
    termsLabel: "terms",
    demoNoCreditCardTitle: "Buy Credits",
    demoNoCreditCardMsg: "Cannot use credit card in Demo version.",
    availablePrefix: "Available",
    willRemainPrefix: "Will remain",
    totalLabel: "Total:",
    paymentPauseTitle: "⚠️ Temporary payment pause",
    walletDelayTitle: "⚠️ Wallet update delay",
    needHelpPrefix: "Need Help? Contact us at",
    siblingDiscountVerifyFailedTitle: "Sibling discount could not be verified",
    siblingDiscountVerifyFailedMsg:
        "We could not finish checking for a sibling discount at another school in your group. The amount shown may be higher than what you owe. If a discount applies, refresh the page or contact us before completing payment.",
    stalePackageTempCleared:
        "Your pending package order expired and was removed. Please choose a package again from the list.",
    pendingPackageNotAvailable:
        "This package is no longer available to purchase. Cancel the pending order and choose a new package.",
    serverTimeNotReady: "Waiting to sync time. Please try again in a moment.",
    packageCopyFinishingByUs:
        "Your package is registered, but some meals are not copied yet. We will finish this for you — nothing you need to do.",
    packageRegisteredDlgTitle: "Meal package",
};

const packagesLangs = { el, en };

export function usePackagesStrings() {
    const [lang] = useContext(langContext);
    return packagesLangs[lang];
}
